import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
  schema?: boolean;
}

export default function FAQAccordion({ items, schema = false }: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = schema
    ? {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: items.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      }
    : null;

  return (
    <>
      {faqSchema && (
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      )}
      <div className="flex flex-col gap-2">
        {items.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-lg border border-background-200 overflow-hidden"
          >
            <button
              onClick={() => toggle(index)}
              className="w-full px-3.5 py-3 flex items-center justify-between gap-2 text-left cursor-pointer"
            >
              <span className="font-heading font-semibold text-foreground-900 text-[13px] pr-2">
                {item.question}
              </span>
              <i
                className={`ri-arrow-down-s-line text-foreground-400 text-base transition-transform duration-200 flex-shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              ></i>
            </button>
            {openIndex === index && (
              <div className="px-3.5 pb-3">
                <p className="text-foreground-600 text-[12px] leading-relaxed">
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}